import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 1. 引入你需要的组件
import Vant from 'vant';
// 2. 引入组件样式
import 'vant/lib/index.css';
import { showToast } from 'vant'
const app = createApp(App);
app.use(Vant);
app.config.globalProperties.$toast = showToast
app.use(store).use(router).mount('#app')
